export const ACTIVITY_API_CONFIG = {
  TRACK: "/activity/track",
} as const;
